<template>
  <div>
    <el-dialog append-to-body
               top="5vh"
               :title="title"
               :visible.sync="dialogFormVisible"
               @close="emitClose"
               :close-on-click-modal="false"
               width="500px">
      <el-form :model="dataForm"
               label-position="right"
               ref="formRules"
               :rules="rules"
               label-width="100px"
               size="small">
        <el-form-item label="课程年份："
                      prop="year">
          <el-select v-model="dataForm.year"
                     style="width:250px"
                     placeholder="请选择考研年份"
                     clearable>
            <el-option label="2025考研"
                       value="2025"></el-option>
            <el-option label="2026考研"
                       value="2026"></el-option>
            <el-option label="2027考研"
                       value="2027"></el-option>
            <el-option label="2028考研"
                       value="2028"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程名称："
                      prop="course_name">
          <el-input v-model="dataForm.course_name"
                    style="width:250px"
                    placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-form-item label="课程状态："
                      prop="status">
          <el-select v-model="dataForm.status"
                     style="width:250px"
                     placeholder="请选择状态"
                     clearable>
            <el-option label="上架"
                       value="1"></el-option>
            <el-option label="下架"
                       value="0"></el-option>

          </el-select>
        </el-form-item>

      </el-form>
      <div class="footer">
        <el-button @click="emitClose(false)">取消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确定</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import { courseAdd, coursePut } from '@/request/api'
import { getStorage } from '@/utils/helper'
import { adminUrl } from '@/utils/helper'

export default {
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: () => {
        return '新建'
      },
    },
    detail: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {},
      rules: {
        course_name: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
        ],
        // year: [
        //   { required: true, message: '请选择班级课程年份', trigger: 'change' },
        // ],
      },
    }
  },
  mounted() {},
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
    detail: {
      handler(val) {
        if (val) {
          this.$set(this.dataForm, 'course_name', val.course_name)
          this.$set(this.dataForm, 'year', val.year)
          this.$set(this.dataForm, 'status', val.status + '')
          console.log('this.dataForm', this.dataForm)
        }
      },
      // immediate: true,
    },
  },
  methods: {
    emitClose() {
      this.$refs['formRules'].resetFields()
      this.dataForm = {}
      this.$emit('close')
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          if (this.title == '新建') {
            let query = {
              course_name: this.dataForm.course_name,
              year: this.dataForm.year,
              status: this.dataForm.status,
            }
            courseAdd(query).then((res) => {
              if (res.data.code == 0) {
                this.$emit('submit')
                this.$message.success('操作成功！')
                this.emitClose()
              }
            })
          } else {
            let query = {
              id: this.detail.id,
              course_name: this.dataForm.course_name,
              year: this.dataForm.year,
              status: this.dataForm.status,
            }
            coursePut(query).then((res) => {
              if (res.data.code == 0) {
                this.$emit('submit')
                this.$message.success('操作成功！')
                this.emitClose()
              }
            })
          }
        } else {
          console.log('error sxubmit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.content {
}
</style>